import script from "./LicensesView.vue?vue&type=script&setup=true&lang=js"
export * from "./LicensesView.vue?vue&type=script&setup=true&lang=js"

import "./LicensesView.vue?vue&type=style&index=0&id=2329a7ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2329a7ee"]])

export default __exports__